module.exports = __webpack_public_path__ + "img/risk-empty.ca0a745f.png";